export const isDev =
  process.env.NEXT_PUBLIC_VERCEL_ENV !== "production" && process.env.VERCEL_ENV !== "production";
